import React from 'react'
import { Table, Menu, ActionIcon, Anchor, Text, Box } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'  

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={150} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const OrderHistoryTable = ({ label, data, actionMethod }) => {
  const navigate = useNavigate()
  
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    const toDetailUser = (dataUser) => {
      if (dataUser !== null) {
        navigate(`/users/${dataUser.id}`)
      }
    }
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.date ? dayjs(val.date).format('DD-MM-YYYY h:mm A') : '-'}</Table.Td>
        <Table.Td tt='capitalize'>{val.is_notified}</Table.Td>
        <Table.Td tt='capitalize'>{val.status_name}</Table.Td>
        <Table.Td >
          <Box>
            <Anchor fz={13} underline="hover" c={val.user !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.user)}>{val.user !== null ? val.user.name : 'Created By System'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td>{val.title}</Table.Td>
        <Table.Td>{val.notes}</Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default OrderHistoryTable